<div class="fc grid-x align-middle" #uploadBox [class.fc--dragging]="dragOver">
  <input
    [accept]="accept"
    class="hide"
    #fileInput
    type="file"
    name="file"
    multiple
    (change)="onFileSelect($event)"
  />
  <div class="cell text-center">
    <ng-container [ngTemplateOutlet]="uploadIconTemplate"></ng-container>
    <p class="small fc__text margin margin--none">
      Drag here or
      <span
        class="weight-700 color-gradient pointer"
        (click)="openChooseFile()"
      >
        browse
      </span>
      to upload
    </p>
    <div class="spacer spacer--v spacer--small"></div>
    <p class="small">
      Accepted files: {{ accept === '*' ? 'all' : accept }}<br /><ng-container
        *ngIf="sizeLimitLabel && sizeLimit > 0"
      >
        Max {{ sizeLimitLabel }}
      </ng-container>
    </p>
    <ng-container *ngIf="imagePreview && imagePreview.files?.length">
      <img class="fc__preview" [src]="imagePreview.src" />
      <p class="fc__text margin margin--none small">
        {{ imagePreview.files[0].name }}
      </p>
      <p class="small fc__text margin margin--none">
        <span
          (click)="onUndo.emit(); imagePreview = null"
          class="weight-700 color-gradient pointer"
        >
          Remove
        </span>
        &nbsp; &nbsp; &nbsp; &nbsp;
        <span
          (click)="onConfirm.emit(imagePreview.files)"
          class="weight-700 color-gradient pointer"
        >
          Upload
        </span>
      </p>
    </ng-container>
  </div>
</div>

<ng-template #uploadIconTemplate>
  <svg
    class="fc__icon"
    width="33px"
    height="29px"
    viewBox="0 0 33 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="SaaS-/-Base"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Ask-a-content"
        transform="translate(-419.000000, -282.000000)"
        fill="#0855ff"
        fill-rule="nonzero"
      >
        <g id="Group" transform="translate(344.000000, 282.000000)">
          <path
            d="M84.9257812,25.0573034 C85.2265625,25.0573034 85.4736328,24.9541199 85.6669922,24.7477528 C85.8603516,24.5413858 85.9570312,24.2970037 85.9570312,24.0146067 C85.9570312,23.7322097 85.8603516,23.4878277 85.6669922,23.2814607 C85.4736328,23.0750936 85.2265625,22.9719101 84.9257812,22.9719101 L81.9609375,22.9719101 C80.6289062,22.9719101 79.4741211,22.428839 78.496582,21.3426966 C77.519043,20.2565543 77.0302734,18.9749064 77.0302734,17.4977528 C77.0302734,16.194382 77.4277344,15.0213483 78.2226562,13.9786517 C79.0175781,12.9359551 79.984375,12.3168539 81.1230469,12.1213483 L82.0576172,11.958427 L81.9931641,10.9808989 L81.9609375,10.9808989 C81.9609375,9.72097378 82.159668,8.54250936 82.5571289,7.44550562 C82.9545898,6.34850187 83.5239258,5.40355805 84.2651367,4.61067416 C85.0063477,3.81779026 85.8925781,3.19868914 86.9238281,2.75337079 C87.9550781,2.30805243 89.1152344,2.08539326 90.4042969,2.08539326 C92.4453125,2.08539326 94.0620117,2.56872659 95.2543945,3.53539326 C96.4467773,4.50205993 97.3115234,5.85430712 97.8486328,7.59213483 L98.0742188,8.30898876 L98.8154297,8.34157303 C99.7822266,8.34157303 100.695312,8.53164794 101.554688,8.91179775 C102.414062,9.29194757 103.176758,9.80243446 103.842773,10.4432584 C104.508789,11.0840824 105.035156,11.8335206 105.421875,12.691573 C105.808594,13.5496255 106.001953,14.4674157 106.001953,15.4449438 C106.001953,16.3355805 105.862305,17.2262172 105.583008,18.1168539 C105.303711,19.0074906 104.90625,19.811236 104.390625,20.5280899 C103.875,21.2449438 103.257324,21.8314607 102.537598,22.2876404 C101.817871,22.7438202 101.017578,22.9719101 100.136719,22.9719101 L97.7841797,22.9719101 C97.5048828,22.9719101 97.2631836,23.0750936 97.059082,23.2814607 C96.8549805,23.4878277 96.7529297,23.7322097 96.7529297,24.0146067 C96.7529297,24.2970037 96.8549805,24.5413858 97.059082,24.7477528 C97.2631836,24.9541199 97.5048828,25.0573034 97.7841797,25.0573034 L100.136719,25.0573034 C101.425781,25.0138577 102.559082,24.6988764 103.536621,24.1123596 C104.51416,23.5258427 105.330566,22.7818352 105.98584,21.8803371 C106.641113,20.978839 107.140625,19.9632959 107.484375,18.8337079 C107.828125,17.7041199 108,16.5745318 108,15.4449438 C108,14.2501873 107.779785,13.12603 107.339355,12.0724719 C106.898926,11.0189139 106.297363,10.0848315 105.534668,9.27022472 C104.771973,8.45561798 103.880371,7.78764045 102.859863,7.26629213 C101.839355,6.74494382 100.749023,6.41910112 99.5888672,6.28876404 C99.2236328,5.3329588 98.7617188,4.46404494 98.203125,3.68202247 C97.6445312,2.9 96.9785156,2.23745318 96.2050781,1.69438202 C95.4316406,1.15131086 94.5615234,0.733146067 93.5947266,0.43988764 C92.6279297,0.146629213 91.5644531,0 90.4042969,0 C88.9003906,0 87.5307617,0.260674157 86.2954102,0.782022472 C85.0600586,1.30337079 83.9858398,2.02565543 83.0727539,2.9488764 C82.159668,3.87209738 81.4291992,4.9582397 80.8813477,6.20730337 C80.3334961,7.45636704 80.0166016,8.80861423 79.9306641,10.2640449 C78.4912109,10.7202247 77.3095703,11.6217228 76.3857422,12.9685393 C75.4619141,14.3153558 75,15.8250936 75,17.4977528 C75,18.5187266 75.1879883,19.4853933 75.5639648,20.3977528 C75.9399414,21.3101124 76.4448242,22.1138577 77.0786133,22.8089888 C77.7124023,23.5041199 78.4482422,24.0526217 79.2861328,24.4544944 C80.1240234,24.856367 81.015625,25.0573034 81.9609375,25.0573034 L84.9257812,25.0573034 Z M91.5,29 C91.7792969,29 92.0209961,28.9022472 92.2250977,28.7067416 C92.4291992,28.511236 92.53125,28.2614232 92.53125,27.9573034 L92.53125,17.4651685 L94.7871094,20.0067416 C94.9375,20.1588015 95.1147461,20.2511236 95.3188477,20.2837079 C95.5229492,20.3162921 95.6894531,20.2565543 95.8183594,20.1044944 L96.0761719,19.941573 C96.2265625,19.7677903 96.3017578,19.5777154 96.3017578,19.3713483 C96.3017578,19.1649813 96.2265625,18.9857678 96.0761719,18.8337079 L92.2734375,14.5977528 L92.2734375,14.5977528 L92.2734375,14.5651685 L92.2734375,14.5651685 L92.015625,14.3044944 C91.9296875,14.217603 91.84375,14.1578652 91.7578125,14.1252809 C91.671875,14.0926966 91.5751953,14.0764045 91.4677734,14.0764045 C91.3818359,14.0764045 91.2905273,14.0926966 91.1938477,14.1252809 C91.097168,14.1578652 91.0166016,14.217603 90.9521484,14.3044944 L90.6943359,14.5651685 L90.6943359,14.5977528 L90.6943359,14.5977528 L86.9560547,18.7685393 C86.8056641,18.9205993 86.7304688,19.0998127 86.7304688,19.3061798 C86.7304688,19.5125468 86.8056641,19.7026217 86.9560547,19.8764045 L87.2138672,20.0393258 C87.3642578,20.1913858 87.5415039,20.2511236 87.7456055,20.2185393 C87.949707,20.1859551 88.1269531,20.093633 88.2773438,19.941573 L90.46875,17.4651685 L90.46875,27.9573034 C90.46875,28.2614232 90.5654297,28.511236 90.7587891,28.7067416 C90.9521484,28.9022472 91.1992188,29 91.5,29 Z"
            id=""
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
